"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpretComparator = exports.interpretLessOrEqual = exports.interpretLess = exports.interpretGreater = exports.interpretGreaterOrEqual = exports.executeIntervalELM = exports.interpretIn = exports.interpretIncludedIn = exports.interpretEqual = exports.getCodesInConcept = exports.interpretEquivalent = exports.interpretNot = exports.interpretFunctionRef = exports.interpretOr = exports.interpretAnd = exports.findPropertyUsage = exports.interpretExpression = exports.parseQueryInfo = void 0;
var cql_execution_1 = require("cql-execution");
var ELMDependencyHelpers_1 = require("../helpers/elm/ELMDependencyHelpers");
var ELMHelpers_1 = require("../helpers/elm/ELMHelpers");
var GracefulError_1 = require("../types/errors/GracefulError");
var CustomErrors_1 = require("../types/errors/CustomErrors");
/**
 * Parse information about a query. This pulls out information about all sources in the query and attempts to parse
 * how the query is filtered.
 *
 * @param library The library ELM the query resides in.
 * @param allELM An array of all the ELM libraries accessible to fqm-execution (includes library from library param)
 * @param queryLocalId The localId for the query we want to get information on.
 * @param valueComparisonLocalId The localId for the initial expression that contained a comparator. Used for tracking
 *                               which clause is the "source" of the comparator in the case of nested expressions outside
 *                                of where statements.
 * @param parameters The parameters used for calculation so they could be reused for re-calculating small bits for CQL.
 *                    "Measurement Period" is the only supported parameter at the moment as it is the only parameter
 *                    seen in eCQMs.
 * @param patient The patient resource being calculated for.
 * @returns Information about the query and how it is filtered.
 */
function parseQueryInfo(library, allELM, queryLocalId, valueComparisonLocalId, parameters, patient) {
    if (parameters === void 0) { parameters = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var expression, query, queryInfo, whereInfo, valueExpression, comparisonInfo, exprRef_1, queryLib, statement, innerQuery, innerQueryInfo, combinedAnd, withError, withError;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!queryLocalId) {
                        throw new Error('QueryLocalId was not provided');
                    }
                    expression = ELMHelpers_1.findClauseInLibrary(library, queryLocalId);
                    if (!((expression === null || expression === void 0 ? void 0 : expression.type) == 'Query')) return [3 /*break*/, 10];
                    query = expression;
                    queryInfo = {
                        localId: query === null || query === void 0 ? void 0 : query.localId,
                        sources: parseSources(query),
                        filter: { type: 'truth' },
                        libraryName: library.library.identifier.id
                    };
                    if (!query.where) return [3 /*break*/, 2];
                    return [4 /*yield*/, interpretExpression(query.where, library, parameters, patient)];
                case 1:
                    whereInfo = _c.sent();
                    queryInfo.filter = whereInfo;
                    _c.label = 2;
                case 2:
                    if (!valueComparisonLocalId) return [3 /*break*/, 4];
                    valueExpression = ELMHelpers_1.findClauseInLibrary(library, valueComparisonLocalId);
                    if (!valueExpression) return [3 /*break*/, 4];
                    return [4 /*yield*/, interpretExpression(valueExpression, library, parameters, patient)];
                case 3:
                    comparisonInfo = _c.sent();
                    if (queryInfo.filter) {
                        if (queryInfo.filter.type === 'and') {
                            queryInfo.filter.children.push(comparisonInfo);
                        }
                        else {
                            queryInfo.filter = {
                                type: 'and',
                                children: [queryInfo.filter, comparisonInfo],
                                libraryName: library.library.identifier.id
                            };
                        }
                    }
                    else {
                        queryInfo.filter = comparisonInfo;
                    }
                    queryInfo.fromExternalClause = true;
                    _c.label = 4;
                case 4:
                    if (!(query.source[0].expression.type === 'ExpressionRef')) return [3 /*break*/, 9];
                    exprRef_1 = query.source[0].expression;
                    queryLib = library;
                    if (exprRef_1.libraryName) {
                        queryLib = ELMDependencyHelpers_1.findLibraryReference(library, allELM, exprRef_1.libraryName);
                    }
                    if (!queryLib) {
                        throw new CustomErrors_1.UnexpectedResource("Cannot Find Referenced Library: " + exprRef_1.libraryName);
                    }
                    statement = queryLib.library.statements.def.find(function (s) { return s.name === exprRef_1.name; });
                    if (!statement) return [3 /*break*/, 8];
                    if (!(statement.expression.type === 'Query')) return [3 /*break*/, 6];
                    innerQuery = statement.expression;
                    return [4 /*yield*/, parseQueryInfo(queryLib, allELM, innerQuery.localId, valueComparisonLocalId, parameters, patient)];
                case 5:
                    innerQueryInfo = _c.sent();
                    // use sources from inner query
                    queryInfo.sources = innerQueryInfo.sources;
                    // replace the filters for this query to match the inner source
                    replaceAliasesInFilters(queryInfo.filter, query.source[0].alias, innerQuery.source[0].alias);
                    // combine filters from inner query by 'AND'ing it with the outer statement and replacing filter info
                    if (innerQuery.where) {
                        combinedAnd = {
                            type: 'and',
                            children: [],
                            notes: 'Combination of multiple queries'
                        };
                        // Add inner query info. merge to the combined 'and' if it is an 'and' itself
                        if (innerQueryInfo.filter.type === 'and') {
                            (_a = combinedAnd.children).push.apply(_a, innerQueryInfo.filter.children);
                        }
                        else {
                            combinedAnd.children.push(innerQueryInfo.filter);
                        }
                        // Add this query info. merge to the combined 'and' if it is an 'and' itself
                        if (queryInfo.filter.type === 'and') {
                            (_b = combinedAnd.children).push.apply(_b, queryInfo.filter.children);
                        }
                        else {
                            combinedAnd.children.push(queryInfo.filter);
                        }
                        // replace the filter info with the combined and
                        queryInfo.filter = combinedAnd;
                    }
                    return [3 /*break*/, 7];
                case 6:
                    withError = {
                        message: "query source referenced a statement that is not a query. " + query.localId + " in " + library.library.identifier.id
                    };
                    queryInfo.withError = withError;
                    _c.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    withError = {
                        message: "query source referenced a statement that could not be found. " + query.localId + " in " + library.library.identifier.id
                    };
                    queryInfo.withError = withError;
                    _c.label = 9;
                case 9: return [2 /*return*/, queryInfo];
                case 10: throw new Error("Clause " + queryLocalId + " in " + library.library.identifier.id + " was not a Query or not found.");
            }
        });
    });
}
exports.parseQueryInfo = parseQueryInfo;
/**
 * Replace the aliases in a tree of filters.
 *
 * @param filter The root filter.
 * @param match The alias to look to replace.
 * @param replace The replacement.
 */
function replaceAliasesInFilters(filter, match, replace) {
    if (filter.type === 'and' || filter.type === 'or') {
        filter.children.forEach(function (filter) {
            replaceAliasesInFilters(filter, match, replace);
        });
    }
    else if (filter.alias === match) {
        filter.alias = replace;
    }
}
/**
 * Parse information about the sources in a given query.
 *
 * @param query The Query expression to parse.
 * @returns Information about each source. This is usually an array of one.
 */
function parseSources(query) {
    var sources = [];
    query.source.forEach(function (source) {
        if (source.expression.type == 'Retrieve') {
            var sourceInfo = {
                sourceLocalId: source.localId,
                retrieveLocalId: source.expression.localId,
                alias: source.alias,
                resourceType: parseDataType(source.expression)
            };
            sources.push(sourceInfo);
        }
    });
    return sources;
}
/**
 * Pulls out the resource type of the retrieve.
 *
 * @param retrieve The retrieve expression to pull out resource type from.
 * @returns FHIR ResourceType name.
 */
function parseDataType(retrieve) {
    return retrieve.dataType.replace(/^(\{http:\/\/hl7.org\/fhir\})?/, '');
}
/**
 * Interprets an expression into a filter tree. This is the central point where the interpreting occurs. This function
 * determines the expression type and sends it to the correct place to be parsed.
 *
 * @param expression The ELM expression/clause to attempt to interpret into a filter.
 * @param library The ELM library, in case it is needed for calculating intervals.
 * @param parameters The parameters used for calculation.
 * @param patient The patient resource.
 * @returns The simpler Filter representation of this clause.
 */
function interpretExpression(expression, library, parameters, patient) {
    return __awaiter(this, void 0, void 0, function () {
        var returnFilter, _a, withError, propUsage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    returnFilter = {
                        type: 'unknown',
                        localId: expression.localId
                    };
                    _a = expression.type;
                    switch (_a) {
                        case 'Equal': return [3 /*break*/, 1];
                        case 'Equivalent': return [3 /*break*/, 2];
                        case 'And': return [3 /*break*/, 3];
                        case 'Or': return [3 /*break*/, 5];
                        case 'IncludedIn': return [3 /*break*/, 7];
                        case 'In': return [3 /*break*/, 8];
                        case 'Not': return [3 /*break*/, 10];
                        case 'GreaterOrEqual': return [3 /*break*/, 11];
                        case 'Greater': return [3 /*break*/, 12];
                        case 'Less': return [3 /*break*/, 13];
                        case 'LessOrEqual': return [3 /*break*/, 14];
                    }
                    return [3 /*break*/, 15];
                case 1:
                    returnFilter = interpretEqual(expression, library);
                    return [3 /*break*/, 16];
                case 2:
                    returnFilter = interpretEquivalent(expression, library);
                    return [3 /*break*/, 16];
                case 3: return [4 /*yield*/, interpretAnd(expression, library, parameters, patient)];
                case 4:
                    returnFilter = _b.sent();
                    return [3 /*break*/, 16];
                case 5: return [4 /*yield*/, interpretOr(expression, library, parameters, patient)];
                case 6:
                    returnFilter = _b.sent();
                    return [3 /*break*/, 16];
                case 7:
                    returnFilter = interpretIncludedIn(expression, library, parameters);
                    return [3 /*break*/, 16];
                case 8: return [4 /*yield*/, interpretIn(expression, library, parameters)];
                case 9:
                    returnFilter = _b.sent();
                    return [3 /*break*/, 16];
                case 10:
                    returnFilter = interpretNot(expression);
                    return [3 /*break*/, 16];
                case 11:
                    returnFilter = interpretGreaterOrEqual(expression, library, patient);
                    return [3 /*break*/, 16];
                case 12:
                    returnFilter = interpretGreater(expression, library);
                    return [3 /*break*/, 16];
                case 13:
                    returnFilter = interpretLess(expression, library);
                    return [3 /*break*/, 16];
                case 14:
                    returnFilter = interpretLessOrEqual(expression, library);
                    return [3 /*break*/, 16];
                case 15:
                    withError = { message: "Don't know how to parse " + expression.type + " expression." };
                    propUsage = findPropertyUsage(expression, expression.localId);
                    if (propUsage) {
                        returnFilter = propUsage;
                    }
                    returnFilter.withError = withError;
                    _b.label = 16;
                case 16:
                    // If we cannot make sense of this expression or find a parameter usage in it, then we should return
                    // an UnknownFilter to denote something is done here that we could not interpret.
                    returnFilter.libraryName = library.library.identifier.id;
                    return [2 /*return*/, returnFilter];
            }
        });
    });
}
exports.interpretExpression = interpretExpression;
/**
 * Recursively search an ELM expression for usage of a property on a query source.
 *
 * @param expression Expression to search for property use in.
 * @param unknownLocalId The localId of the parent express that should be identified as the clause we are unable to parse.
 * @returns An `UnknownFilter` describing the attribute that was accessed or null if none was found.
 */
function findPropertyUsage(expression, unknownLocalId) {
    if (expression.type === 'Property') {
        var propRef = expression;
        if (propRef.scope) {
            return {
                type: 'unknown',
                alias: propRef.scope,
                attribute: propRef.path,
                localId: unknownLocalId
            };
        }
    }
    else if (Array.isArray(expression.operand)) {
        for (var i = 0; i < expression.operand.length; i++) {
            var propInfo = findPropertyUsage(expression.operand[i], unknownLocalId);
            if (propInfo) {
                return propInfo;
            }
        }
    }
    else if (expression.operand) {
        return findPropertyUsage(expression.operand, unknownLocalId);
    }
    return null;
}
exports.findPropertyUsage = findPropertyUsage;
/**
 * Parses an `and` expression into a tree of filters. This will flatten directly nested `and` statements.
 *
 * @param andExpression The and expression to interpret.
 * @param library The library the elm is in.
 * @param parameters The original calculation parameters.
 * @param patient The patient resource.
 * @returns The filter tree for this and expression.
 */
function interpretAnd(andExpression, library, parameters, patient) {
    return __awaiter(this, void 0, void 0, function () {
        var andInfo, _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    andInfo = { type: 'and', children: [] };
                    if (!(andExpression.operand[0].type == 'And')) return [3 /*break*/, 2];
                    _b = (_a = (_l = andInfo.children).push).apply;
                    _c = [_l];
                    return [4 /*yield*/, interpretAnd(andExpression.operand[0], library, parameters, patient)];
                case 1:
                    _b.apply(_a, _c.concat([(_o.sent()).children]));
                    return [3 /*break*/, 4];
                case 2:
                    _e = (_d = andInfo.children).push;
                    return [4 /*yield*/, interpretExpression(andExpression.operand[0], library, parameters, patient)];
                case 3:
                    _e.apply(_d, [_o.sent()]);
                    _o.label = 4;
                case 4:
                    if (!(andExpression.operand[1].type == 'And')) return [3 /*break*/, 6];
                    _g = (_f = (_m = andInfo.children).push).apply;
                    _h = [_m];
                    return [4 /*yield*/, interpretAnd(andExpression.operand[1], library, parameters, patient)];
                case 5:
                    _g.apply(_f, _h.concat([(_o.sent()).children]));
                    return [3 /*break*/, 8];
                case 6:
                    _k = (_j = andInfo.children).push;
                    return [4 /*yield*/, interpretExpression(andExpression.operand[1], library, parameters, patient)];
                case 7:
                    _k.apply(_j, [_o.sent()]);
                    _o.label = 8;
                case 8:
                    andInfo.children = andInfo.children.filter(function (filter) { return (filter === null || filter === void 0 ? void 0 : filter.type) !== 'truth'; });
                    return [2 /*return*/, andInfo];
            }
        });
    });
}
exports.interpretAnd = interpretAnd;
/**
 * Parses an `or` expression into a tree of filters. This will flatten directly nested `or` statements.
 *
 * @param orExpression The or expression to interpret.
 * @param library The library the elm is in.
 * @param parameters The original calculation parameters.
 * @param patient The patient resource.
 * @returns The filter tree for this or expression.
 */
function interpretOr(orExpression, library, parameters, patient) {
    return __awaiter(this, void 0, void 0, function () {
        var orInfo, _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    orInfo = { type: 'or', children: [] };
                    if (!(orExpression.operand[0].type == 'Or')) return [3 /*break*/, 2];
                    _b = (_a = (_l = orInfo.children).push).apply;
                    _c = [_l];
                    return [4 /*yield*/, interpretOr(orExpression.operand[0], library, parameters, patient)];
                case 1:
                    _b.apply(_a, _c.concat([(_o.sent()).children]));
                    return [3 /*break*/, 4];
                case 2:
                    _e = (_d = orInfo.children).push;
                    return [4 /*yield*/, interpretExpression(orExpression.operand[0], library, parameters, patient)];
                case 3:
                    _e.apply(_d, [_o.sent()]);
                    _o.label = 4;
                case 4:
                    if (!(orExpression.operand[1].type == 'Or')) return [3 /*break*/, 6];
                    _g = (_f = (_m = orInfo.children).push).apply;
                    _h = [_m];
                    return [4 /*yield*/, interpretOr(orExpression.operand[1], library, parameters, patient)];
                case 5:
                    _g.apply(_f, _h.concat([(_o.sent()).children]));
                    return [3 /*break*/, 8];
                case 6:
                    _k = (_j = orInfo.children).push;
                    return [4 /*yield*/, interpretExpression(orExpression.operand[1], library, parameters, patient)];
                case 7:
                    _k.apply(_j, [_o.sent()]);
                    _o.label = 8;
                case 8:
                    orInfo.children = orInfo.children.filter(function (filter) { return (filter === null || filter === void 0 ? void 0 : filter.type) !== 'truth'; });
                    return [2 /*return*/, orInfo];
            }
        });
    });
}
exports.interpretOr = interpretOr;
/**
 * Attempt to interpret what a FunctionRef is doing. This currently checks to see if it can be treated as a passthrough
 * to the property accessed in the operand.
 *
 * @param functionRef The function ref to look at.
 * @returns Usually an ELMProperty expression for the operand if it can be considered a passthrough.
 */
function interpretFunctionRef(functionRef, library) {
    if (functionRef.libraryName) {
        var libraryId = ELMDependencyHelpers_1.findLibraryReferenceId(library, functionRef.libraryName);
        // from fhir helpers or MAT Global or fhir common
        if (libraryId === 'FHIRHelpers' ||
            libraryId === 'MATGlobalCommonFunctions' ||
            libraryId === 'FHIRCommon' ||
            libraryId === 'MATGlobalCommonFunctionsFHIR4') {
            switch (functionRef.name) {
                case 'ToString':
                case 'ToConcept':
                case 'ToInterval':
                case 'ToDateTime':
                case 'Normalize Interval':
                case 'Latest':
                case 'ToQuantity':
                    // Act as pass through for all of the above
                    if (functionRef.operand[0].type == 'Property') {
                        return functionRef.operand[0];
                    }
                    else if (functionRef.operand[0].type === 'As' &&
                        functionRef.operand[0].operand.type == 'Property') {
                        return functionRef.operand[0].operand;
                    }
                    break;
                default:
                    break;
            }
        }
        else {
            return {
                message: "do not know how to interpret function ref " + functionRef.libraryName + ".\"" + functionRef.name + "\""
            };
        }
    }
}
exports.interpretFunctionRef = interpretFunctionRef;
/**
 * Interprets a `not` expression into a filter. This currently is able to handle "not null" and superfluous checks
 * that cql-to-elm adds (i.e. a check to see if the end of "Measurement Period" is not null)
 *
 * This is commonly seen in measures as an `Observation.value is not null`.
 *
 * @param not The ELM `Not` expression to parse.
 * @returns The interpreted filter. This may be a TautologyFilter that can be removed.
 */
function interpretNot(not) {
    var errorInfo = {};
    if (not.operand.type === 'IsNull') {
        var isNull = not.operand;
        if (isNull.operand.type === 'Property') {
            var propRef = isNull.operand;
            if (propRef.scope) {
                return {
                    type: 'notnull',
                    attribute: propRef.path,
                    alias: propRef.scope,
                    localId: not.localId
                };
            }
        }
        else if (isNull.operand.type === 'End' || isNull.operand.type === 'Start') {
            var endOrStart = isNull.operand;
            // if it is "Measurement Period" we can return that this will always be true/removed
            if (endOrStart.operand.type === 'ParameterRef' &&
                endOrStart.operand.name === 'Measurement Period') {
                return { type: 'truth' };
            }
        }
        else {
            errorInfo.message = "could not handle 'isNull' inside 'not' for expression type " + isNull.operand.type;
        }
    }
    else {
        errorInfo.message = "could not handle 'not' for expression type " + not.operand.type;
    }
    return { type: 'unknown', withError: errorInfo };
}
exports.interpretNot = interpretNot;
/**
 * Parses an ELM equivalent expression into a filter. This currently handles checks against literals and checks against
 * a concept reference.
 *
 * @param equal The ELM equivalent clause to parse.
 * @param library The library the clause resides in.
 * @returns The filter representation.
 */
function interpretEquivalent(equal, library) {
    var propRef = null;
    if (equal.operand[0].type == 'FunctionRef') {
        propRef = interpretFunctionRef(equal.operand[0], library);
    }
    else if (equal.operand[0].type == 'Property') {
        propRef = equal.operand[0];
    }
    if (propRef == null) {
        var withError = { message: 'could not resolve property ref for Equivalent' };
        return { type: 'unknown', withError: withError };
    }
    if (GracefulError_1.isOfTypeGracefulError(propRef)) {
        return { type: 'unknown', withError: propRef };
    }
    if (equal.operand[1].type == 'Literal') {
        var literal = equal.operand[1];
        if (propRef.scope && literal.value) {
            return {
                type: 'equals',
                alias: propRef.scope,
                value: literal.value,
                attribute: propRef.path,
                localId: equal.localId
            };
        }
        else {
            var withError = { message: 'Property reference scope or literal value were not found.' };
            return { type: 'unknown', withError: withError };
        }
    }
    if (equal.operand[1].type == 'ConceptRef') {
        var conceptRef = equal.operand[1];
        if (propRef.scope) {
            return {
                type: 'in',
                alias: propRef.scope,
                attribute: propRef.path,
                valueCodingList: getCodesInConcept(conceptRef.name, library),
                localId: equal.localId
            };
        }
        else {
            var withError = { message: 'Property reference scope was not found.' };
            return { type: 'unknown', withError: withError };
        }
    }
    return { type: 'unknown' };
}
exports.interpretEquivalent = interpretEquivalent;
/**
 * Gets a list of codes in a CQL concept reference by name. These are returned as
 * FHIR Codings.
 *
 * @param name Name of the concept.
 * @param library The library elm the concept should be found in.
 * @returns A list of codings in the concept
 */
function getCodesInConcept(name, library) {
    var _a;
    var concept = (_a = library.library.concepts) === null || _a === void 0 ? void 0 : _a.def.find(function (concept) { return concept.name === name; });
    if (concept) {
        var codes_1 = [];
        concept.code.map(function (codeRef) {
            var _a, _b, _c;
            var code = (_a = library.library.codes) === null || _a === void 0 ? void 0 : _a.def.find(function (code) { return code.name == codeRef.name; });
            if (code) {
                codes_1.push({
                    code: code === null || code === void 0 ? void 0 : code.id,
                    system: (_c = (_b = library.library.codeSystems) === null || _b === void 0 ? void 0 : _b.def.find(function (systemRef) { return (code === null || code === void 0 ? void 0 : code.codeSystem.name) === systemRef.name; })) === null || _c === void 0 ? void 0 : _c.id
                });
            }
        });
        return codes_1;
    }
    return [];
}
exports.getCodesInConcept = getCodesInConcept;
/**
 * Parses an ELM equal expression into a filter. This currently only handles checks against literal values.
 *
 * @param equal The equal expression to be parsed.
 * @returns Filter representing the equal filter.
 */
function interpretEqual(equal, library) {
    var propRef = null;
    var withError = { message: 'An unknown error ocurred.' };
    if (equal.operand[0].type == 'FunctionRef') {
        propRef = interpretFunctionRef(equal.operand[0], library);
    }
    else if (equal.operand[0].type == 'Property') {
        propRef = equal.operand[0];
    }
    if (GracefulError_1.isOfTypeGracefulError(propRef)) {
        return { type: 'unknown', withError: propRef };
    }
    var literal = null;
    if (equal.operand[1].type == 'Literal') {
        literal = equal.operand[1];
    }
    if ((propRef === null || propRef === void 0 ? void 0 : propRef.scope) && (literal === null || literal === void 0 ? void 0 : literal.value)) {
        return {
            type: 'equals',
            alias: propRef.scope,
            value: literal.value,
            attribute: propRef.path,
            localId: equal.localId
        };
    }
    else {
        withError = { message: 'could not find attribute or literal for Equal' };
    }
    return { type: 'unknown', withError: withError };
}
exports.interpretEqual = interpretEqual;
/**
 * Parses an `IncludedIn` clause to a simpler filter representation. Currently handles comparisons to the
 * "Measurement Period" parameter.
 *
 * @param includedIn IncludedId expression to be parsed.
 * @param library The library the expression resides in.
 * @param parameters The original parameters used for calculation.
 * @returns Filter representation of the IncludedIn clause.
 */
function interpretIncludedIn(includedIn, library, parameters) {
    var propRef = null;
    var withError = { message: 'An unknown error occured' };
    if (includedIn.operand[0].type == 'FunctionRef') {
        propRef = interpretFunctionRef(includedIn.operand[0], library);
    }
    else if (includedIn.operand[0].type == 'Property') {
        propRef = includedIn.operand[0];
    }
    if (propRef == null) {
        var withError_1 = {
            message: "could not resolve property ref for IncludedIn:" + includedIn.localId + ". first operand is a " + includedIn.operand[0].type
        };
        return { type: 'unknown', withError: withError_1 };
    }
    if (GracefulError_1.isOfTypeGracefulError(propRef)) {
        return { type: 'unknown', withError: propRef };
    }
    if (includedIn.operand[1].type == 'ParameterRef') {
        var paramName = includedIn.operand[1].name;
        var valuePeriod = {};
        // If this parameter is known and is an interval we can use it
        if (parameters[paramName] && parameters[paramName].isInterval) {
            valuePeriod.start = parameters[paramName].start().toString().replace('+00:00', 'Z');
            valuePeriod.end = parameters[paramName].end().toString().replace('+00:00', 'Z');
        }
        else {
            withError = {
                message: "could not find parameter \"" + paramName + "\" or it was not an interval."
            };
            return { type: 'unknown', alias: propRef.scope, attribute: propRef.path, withError: withError };
        }
        if (propRef.scope) {
            return {
                type: 'during',
                alias: propRef.scope,
                valuePeriod: valuePeriod,
                attribute: propRef.path,
                localId: includedIn.localId
            };
        }
        else {
            withError = { message: 'could not find scope of property ref' };
        }
    }
    else {
        withError = {
            message: 'could not resolve IncludedIn operand[1] ' + includedIn.operand[1].type
        };
    }
    return { type: 'unknown', withError: withError };
}
exports.interpretIncludedIn = interpretIncludedIn;
/**
 * Parses a `in` expression. This may seen in CQL as 'during'. This can handle two situations.
 *  - A value, such as a code, is checked to be if it's in a list of literals. ex. status in { 'complete', 'amended' }
 *  - A time value is being checked if it is during a calculated interval. Usually based on "Measurement Period".
 *
 * @param inExpr The `in` expression to parse.
 * @param library The library the expression resides in.
 * @param parameters The parameters used for calculation.
 * @returns Filter representation of the In clause.
 */
function interpretIn(inExpr, library, parameters) {
    return __awaiter(this, void 0, void 0, function () {
        var propRef, withError, startOrEnd, suffix, foundPropUsage, period, paramName, valuePeriod;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    propRef = null;
                    withError = { message: 'An unknown error occured' };
                    if (inExpr.operand[0].type == 'FunctionRef') {
                        propRef = interpretFunctionRef(inExpr.operand[0], library);
                    }
                    else if (inExpr.operand[0].type == 'Property') {
                        propRef = inExpr.operand[0];
                    }
                    else if (inExpr.operand[0].type == 'End' || inExpr.operand[0].type == 'Start') {
                        startOrEnd = inExpr.operand[0];
                        suffix = startOrEnd.type === 'End' ? '.end' : '.start';
                        if (startOrEnd.operand.type == 'FunctionRef') {
                            propRef = interpretFunctionRef(startOrEnd.operand, library);
                        }
                        else if (startOrEnd.operand.type == 'Property') {
                            propRef = startOrEnd.operand;
                        }
                        if (propRef && !GracefulError_1.isOfTypeGracefulError(propRef)) {
                            propRef = {
                                type: 'Property',
                                path: (propRef === null || propRef === void 0 ? void 0 : propRef.path) + suffix,
                                scope: propRef === null || propRef === void 0 ? void 0 : propRef.scope,
                                localId: propRef === null || propRef === void 0 ? void 0 : propRef.localId,
                                locator: propRef === null || propRef === void 0 ? void 0 : propRef.locator,
                                source: propRef === null || propRef === void 0 ? void 0 : propRef.source
                            };
                        }
                    }
                    if (propRef == null) {
                        withError.message = "could not resolve property ref for In:" + inExpr.localId + ". first operand is a " + inExpr.operand[0].type;
                        foundPropUsage = findPropertyUsage(inExpr, inExpr.localId);
                        if (foundPropUsage) {
                            withError.message = withError.message.concat('\n', "  found property ref \"" + foundPropUsage.alias + "." + foundPropUsage.attribute + "\" in first operand.");
                            return [2 /*return*/, __assign(__assign({}, foundPropUsage), { withError: withError })];
                        }
                        return [2 /*return*/, { type: 'unknown', withError: withError }];
                    }
                    if (GracefulError_1.isOfTypeGracefulError(propRef)) {
                        return [2 /*return*/, { type: 'unknown', withError: propRef }];
                    }
                    if (!(inExpr.operand[1].type == 'List')) return [3 /*break*/, 1];
                    if (propRef.scope) {
                        return [2 /*return*/, {
                                type: 'in',
                                alias: propRef.scope,
                                attribute: propRef.path,
                                valueList: inExpr.operand[1].element.map(function (item) { return item.value; }),
                                localId: inExpr.localId
                            }];
                    }
                    else {
                        withError.message = 'Could not find scope for property reference';
                        return [2 /*return*/, { type: 'unknown', withError: withError }];
                    }
                    return [3 /*break*/, 4];
                case 1:
                    if (!(inExpr.operand[1].type == 'Interval')) return [3 /*break*/, 3];
                    return [4 /*yield*/, executeIntervalELM(inExpr.operand[1], library, parameters)];
                case 2:
                    period = _a.sent();
                    if (GracefulError_1.isOfTypeGracefulError(period)) {
                        return [2 /*return*/, {
                                type: 'unknown',
                                localId: inExpr.localId,
                                alias: propRef.scope,
                                attribute: propRef.path,
                                withError: period
                            }];
                    }
                    else if (propRef.scope) {
                        return [2 /*return*/, {
                                type: 'during',
                                alias: propRef.scope,
                                attribute: propRef.path,
                                valuePeriod: period
                            }];
                    }
                    else {
                        withError.message = 'could not resolve property scope';
                    }
                    return [3 /*break*/, 4];
                case 3:
                    if (inExpr.operand[1].type == 'ParameterRef') {
                        paramName = inExpr.operand[1].name;
                        valuePeriod = {};
                        // If this parameter is known and is an interval we can use it
                        if (parameters[paramName] && parameters[paramName].isInterval) {
                            valuePeriod.start = parameters[paramName].start().toString().replace('+00:00', 'Z');
                            valuePeriod.end = parameters[paramName].end().toString().replace('+00:00', 'Z');
                        }
                        else {
                            withError = {
                                message: "could not find parameter \"" + paramName + "\" or it was not an interval."
                            };
                            return [2 /*return*/, { type: 'unknown', alias: propRef.scope, attribute: propRef.path, withError: withError }];
                        }
                        if (propRef.scope) {
                            return [2 /*return*/, {
                                    type: 'during',
                                    alias: propRef.scope,
                                    valuePeriod: valuePeriod,
                                    attribute: propRef.path,
                                    localId: inExpr.localId
                                }];
                        }
                        else {
                            withError = { message: 'could not find scope of property ref' };
                        }
                    }
                    else {
                        withError.message = 'could not resolve In operand[1] ' + inExpr.operand[1].type;
                    }
                    _a.label = 4;
                case 4: return [2 /*return*/, { type: 'unknown', withError: withError }];
            }
        });
    });
}
exports.interpretIn = interpretIn;
/**
 * Calculates an ELM expression that creates a CQL Interval using the cql-execution engine.
 * This is used to create the periods that are based on the "Measurement Period".
 *
 * @param intervalExpr ELM Interval Expression to execute.
 * @param library The library it belongs in. This is needed to identify parameters.
 * @param parameters The execution parameters.
 * @returns A FHIR Period like structure with start and end of the calculated interval.
 */
function executeIntervalELM(intervalExpr, library, parameters) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var propRefInInterval, withError, intervalExecExpr, ctx, interval;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    propRefInInterval = findPropertyUsage(intervalExpr, undefined);
                    withError = {
                        message: 'An unknown error occurred while calculating CQL intervals based on measurement period'
                    };
                    if (propRefInInterval) {
                        withError.message = 'cannot handle intervals constructed on query data right now';
                        return [2 /*return*/, withError];
                    }
                    intervalExecExpr = new cql_execution_1.Expression({ operand: intervalExpr });
                    ctx = new cql_execution_1.PatientContext(new cql_execution_1.Library(library), null, null, parameters);
                    return [4 /*yield*/, ((_a = intervalExecExpr.arg) === null || _a === void 0 ? void 0 : _a.execute(ctx))];
                case 1:
                    interval = _b.sent();
                    if (interval != null && interval.start() != null && interval.end() != null) {
                        return [2 /*return*/, {
                                start: interval.start().toString().replace('+00:00', 'Z'),
                                end: interval.end().toString().replace('+00:00', 'Z'),
                                interval: interval
                            }];
                    }
                    else {
                        return [2 /*return*/, withError];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.executeIntervalELM = executeIntervalELM;
/**
 * Parses a `GreaterOrEqual` expression. This can handle one situation at the moment.
 *  - A time on a source attribute is expected to happen after the patient's Nth birthDate.
 *     ex: Global."CalendarAgeInYearsAt"(FHIRHelpers.ToDate(Patient.birthDate), start of Global."Normalize Interval"(HPVTest.effective)) >= 30
 *
 * @param greaterOrEqualExpr The GreaterOrEqual expression to interpret.
 * @param library The library it belongs in. This is needed to identify parameters.
 * @param parameters The execution parameters.
 * @param patient The patient we are executing for. This is where the birthDate is fetched if referenced.
 * @returns Filter representation of the GreaterOrEqual clause. This will be Unknown, During, or Value depending on if it can be parsed or not.
 */
function interpretGreaterOrEqual(greaterOrEqualExpr, library, patient) {
    // TODO: Consider breaking out a compareBirthdate function and calling it in interpretComparator instead
    // look at first param if it is function ref to calendar age in years at.
    var withError = { message: 'An unknown error occurred while interpreting greater or equal filter' };
    if (greaterOrEqualExpr.operand[0].type === 'FunctionRef') {
        var functionRef = greaterOrEqualExpr.operand[0];
        // Check if it is "Global.CalendarAgeInYearsAt"
        if (patient && functionRef.name === 'CalendarAgeInYearsAt' && functionRef.libraryName === 'Global') {
            var calAgeRef = functionRef;
            // ensure the first operand is the patient birthdate.
            if (calAgeRef.operand[0].type === 'ToDateTime' &&
                calAgeRef.operand[0].operand.type === 'FunctionRef' &&
                calAgeRef.operand[0].operand.name === 'ToDate' &&
                calAgeRef.operand[0].operand.operand[0].type === 'Property' &&
                calAgeRef.operand[0].operand.operand[0].path === 'birthDate') {
                // figure out what the attribute on the property is
                var attrExpr = calAgeRef.operand[1];
                var propRef = null;
                if (attrExpr.type === 'FunctionRef') {
                    propRef = interpretFunctionRef(attrExpr, library);
                }
                else if (attrExpr.type === 'Property') {
                    propRef = attrExpr;
                }
                else if (attrExpr.type === 'Start' || attrExpr.type === 'End') {
                    var suffix = attrExpr.type === 'End' ? '.end' : '.start';
                    if (attrExpr.operand.type == 'FunctionRef') {
                        propRef = interpretFunctionRef(attrExpr.operand, library);
                    }
                    else if (attrExpr.operand.type == 'Property') {
                        propRef = attrExpr.operand;
                    }
                    if (propRef && !GracefulError_1.isOfTypeGracefulError(propRef)) {
                        propRef = {
                            type: 'Property',
                            path: (propRef === null || propRef === void 0 ? void 0 : propRef.path) + suffix,
                            scope: propRef === null || propRef === void 0 ? void 0 : propRef.scope,
                            localId: propRef === null || propRef === void 0 ? void 0 : propRef.localId,
                            locator: propRef === null || propRef === void 0 ? void 0 : propRef.locator,
                            source: propRef === null || propRef === void 0 ? void 0 : propRef.source
                        };
                    }
                }
                // if propRef is defined that means we found the attribute on the source resource
                if (propRef == null) {
                    withError.message = 'Could not resolve the property referenced in CalendarAgeInYearsAt';
                    return { type: 'unknown', withError: withError };
                }
                if (GracefulError_1.isOfTypeGracefulError(propRef)) {
                    return { type: 'unknown', withError: propRef };
                }
                // If the second operand in the GreaterOrEqual expression is a literal then we can move forward using the literal
                // as the number of years to add to the birthDate.
                if (greaterOrEqualExpr.operand[1].type === 'Literal') {
                    var years = greaterOrEqualExpr.operand[1].value;
                    if (patient.birthDate) {
                        // Clone patient cql-execution birthDate ensure it is a DateTime then wipe out hours, minutes, seconds,
                        // and milliseconds. Then add the number of years.
                        var birthDate = patient.birthDate.value.copy().getDateTime();
                        birthDate.hour = 0;
                        birthDate.minute = 0;
                        birthDate.second = 0;
                        birthDate.millisecond = 0;
                        birthDate.timezoneOffset = 0;
                        var birthDateOffset = birthDate.add(years, cql_execution_1.DateTime.Unit.YEAR);
                        // create an interval with this offset as the start and no end date.
                        var period = {
                            start: birthDateOffset.toString().replace('+00:00', 'Z'),
                            interval: new cql_execution_1.Interval(birthDateOffset, null, true, false)
                        };
                        // build the DuringFilter to return.
                        return {
                            type: 'during',
                            alias: propRef.scope,
                            attribute: propRef.path,
                            valuePeriod: period,
                            localId: greaterOrEqualExpr.localId,
                            notes: "Compares against the patient's birthDate (" + years + " years)"
                        };
                    }
                    else {
                        withError.message = 'Patient data had no birthDate';
                        return {
                            type: 'unknown',
                            alias: propRef.scope,
                            attribute: propRef.path,
                            localId: greaterOrEqualExpr.localId,
                            notes: "Compares against the patient's birthDate. But patient did not have birthDate.",
                            withError: withError
                        };
                    }
                }
            }
            // Fallback if the first operand cannot be parsed or parsing falls through.
            return { type: 'unknown', withError: withError };
        }
        else {
            // If the function referenced is not "CalendarAgeInYearsAt".
            return interpretComparator(greaterOrEqualExpr, library, 'ge');
        }
    }
    else {
        return interpretComparator(greaterOrEqualExpr, library, 'ge');
    }
}
exports.interpretGreaterOrEqual = interpretGreaterOrEqual;
/**
 * Parses a `Greater` expression. Currently used as a wrapper for interpretComparator but may become more robust if functionality
 * specific to 'Greater' expressions is needed
 * @param greater The Greater expression to interpret.
 * @param library The library it belongs in. This is needed to identify parameters.
 * @returns Filter representation of the Greater clause. This will be Unknown or Value depending on if it can be parsed or not.
 */
function interpretGreater(greater, library) {
    return interpretComparator(greater, library, 'gt');
}
exports.interpretGreater = interpretGreater;
/**
 * Parses a `Less` expression. Currently used as a wrapper for interpretComparator but may become more robust if functionality
 * specific to 'Less' expressions is needed
 * @param less The Less expression to interpret.
 * @param library The library it belongs in. This is needed to identify parameters.
 * @returns Filter representation of the Less clause. This will be Unknown or Value depending on if it can be parsed or not.
 */
function interpretLess(less, library) {
    return interpretComparator(less, library, 'lt');
}
exports.interpretLess = interpretLess;
/**
 * Parses a `LessOrEqual` expression. Currently used as a wrapper for interpretComparator but may become more robust if functionality
 * specific to 'LessOrEqual' expressions is needed
 * @param lessOrEqual The LessOrEqual expression to interpret.
 * @param library The library it belongs in. This is needed to identify parameters.
 * @returns Filter representation of the LessOrEqual clause. This will be Unknown or Value depending on if it can be parsed or not.
 */
function interpretLessOrEqual(lessOrEqual, library) {
    return interpretComparator(lessOrEqual, library, 'le');
}
exports.interpretLessOrEqual = interpretLessOrEqual;
/**
 * Default code for parsing a miscellaneous comparator expression
 * @param comparatorELM The elm comparator expression to interpret.
 * @param library The library it belongs in. This is needed to identify parameters.
 * @param comparatorString a string determining the type of comparator passed into the function
 * @returns Filter representation of the comparator clause this will be Unknown or Value depending on if it can be parsed or not.
 */
function interpretComparator(comparatorELM, library, comparatorString) {
    var propRef = null;
    if (comparatorELM.operand[0].type == 'FunctionRef') {
        propRef = interpretFunctionRef(comparatorELM.operand[0], library);
    }
    else if (comparatorELM.operand[0].type == 'Property') {
        propRef = comparatorELM.operand[0];
    }
    if (propRef == null) {
        var withError = {
            message: "could not resolve property ref for comparator: " + comparatorELM.type
        };
        return { type: 'unknown', withError: withError };
    }
    if (GracefulError_1.isOfTypeGracefulError(propRef)) {
        return { type: 'unknown', withError: propRef };
    }
    var valueFilter = {
        type: 'value',
        comparator: comparatorString
    };
    var op = comparatorELM.operand[1];
    switch (op.type) {
        case 'Literal':
            var literal = op;
            if (literal.valueType === 'Boolean') {
                valueFilter.valueBoolean = literal.value;
            }
            else if (literal.valueType === 'Integer') {
                valueFilter.valueInteger = literal.value;
            }
            else {
                valueFilter.valueString = literal.value;
            }
            break;
        case 'Quantity':
            var quantity = op;
            valueFilter.valueQuantity = { value: quantity.value, unit: quantity.unit };
            break;
        case 'Ratio':
            var ratio = op;
            valueFilter.valueRatio = { denominator: ratio.denominator, numerator: ratio.numerator };
            break;
        // TODO: Add handling for ELMRange here
        default:
            var withError = {
                message: "cannot handle unsupported operand type: " + op.type + " in comparator: " + comparatorELM.type
            };
            return { type: 'unknown', withError: withError };
    }
    if (propRef.scope) {
        valueFilter.alias = propRef.scope;
    }
    if (propRef.path) {
        valueFilter.attribute = propRef.path;
    }
    return valueFilter;
}
exports.interpretComparator = interpretComparator;
//# sourceMappingURL=QueryFilterParser.js.map